export const routes = {
  login: `/login`,
  authorize: `/authorize`,
  home: `/home`,
  chart: `/chart`,
  watchlist: `/watchlist`,
  trading: `/trading`,
  portfolio: `/portfolio`,
  future: `/future`,
  account: `/account`,
  userSettings: `/settings/user`,
  notificationsSettings: `/settings/notifications`,
  dataServiceManagement: `/settings/data-service`,
  siteSettings: `/settings/site`,
  notFound: `/not-found`,
  app: `/app`,
};
